import { FC } from 'react';

const UndoIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M6.98593 12.7988C7.23 13.0429 7.62645 13.0429 7.87053 12.7988C8.11444 12.5548 8.11428 12.1591 7.87053 11.915L4.50871 8.55322L13.6664 8.55322C15.1622 8.55322 16.3747 9.76584 16.3748 11.2616L16.3748 16.5C16.3748 16.8451 16.6547 17.1249 16.9998 17.125C17.3449 17.125 17.6248 16.8452 17.6248 16.5L17.6248 11.2616C17.6247 9.07548 15.8525 7.30322 13.6664 7.30322L4.50871 7.30322L7.87053 3.94222C8.11447 3.69826 8.11425 3.30253 7.87053 3.05843C7.62645 2.81435 7.23 2.81435 6.98593 3.05843L2.55803 7.48633C2.31397 7.73039 2.31401 8.12603 2.55803 8.37012L6.98593 12.7988Z"
      fill="#010203"
    />
  </svg>
);

export default UndoIcon;
